import { Intake } from "../types/intake"

export const intakeQueryKeys = {
  all: ["intakes"] as const,
  detail: (id: Intake["id"]) => [...intakeQueryKeys.all, id] as const,
  locations: (studentId: number) =>
    [...intakeQueryKeys.all, studentId, "locations"] as const,
  dates: ({
    locationId,
    studentId,
  }: {
    locationId?: number
    studentId?: number
  }) => [...intakeQueryKeys.all, locationId, studentId, "dates"] as const,
  upcoming: () => [...intakeQueryKeys.all, "upcoming"] as const,
  results: (id: Intake["id"]) =>
    [...intakeQueryKeys.detail(id), "results"] as const,
  resultStudent: (intakeId: Intake["id"], studentId: number) =>
    [...intakeQueryKeys.results(intakeId), "student", studentId] as const,
}
